import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';
import tabsStyles from './Tabs.styles.esm.js';
import { useTabsContext } from './TabsContext.esm.js';

const TabsTrigger = React__default.forwardRef((_a, ref) => {
    var { className, children, icon, onClick, value } = _a, props = __rest(_a, ["className", "children", "icon", "onClick", "value"]);
    const { variant, inverse, onValueChange, showIcon } = useTabsContext();
    const { trigger, icon: iconClass } = tabsStyles({ variant, inverse });
    const handleOnClick = (event) => {
        if (value && onValueChange) {
            onValueChange(value);
        }
        if (onClick) {
            onClick(event);
        }
    };
    return (jsxs(RadixTabs.Trigger, Object.assign({ ref: ref, value: value, className: trigger(), onClick: handleOnClick }, props, { children: [variant === "text" && (jsxs(Fragment, { children: [icon && showIcon && jsx("span", { className: iconClass(), children: icon }), jsx("span", { children: children })] })), variant !== "text" && children] })));
});
TabsTrigger.displayName = "Tabs.Trigger";

export { TabsTrigger };
